import { Injectable, inject, signal } from '@angular/core';
import { BehaviorSubject, map, Observable, Subject, tap } from 'rxjs';
import { CCDropdownModelSingle, CCPostModel, DynamicFormConfig } from '../types/dynamic-form.types';
import { DataManager, WebApiAdaptor } from '@syncfusion/ej2-data';
import { ApiHttpService, ILayoutConfig, LayoutService } from '@itm/services';

@Injectable({
  providedIn: 'root'
})
export class DynamicFormService {
  private readonly layoutService = inject(LayoutService);
  private readonly _http = inject(ApiHttpService);
  //TODO task1
  // LayoutConfigSig! = this.layoutService.LayoutConfigSig;
  LayoutConfigSig = signal<ILayoutConfig>(undefined);
  //TODO get from route
  constructor() { }


  getDropdownRemoteDataEJS(remoteUrl: string): DataManager {
    // bind the DataManager instance to dataSource property
    const url = `${this._http.GET_API_URL()}${remoteUrl}`;
    return new DataManager({
      url: url,
      adaptor: new WebApiAdaptor,
      crossDomain: true,

    });
  }
  getDropdownRemoteDataEJS2(remoteUrl: string): Observable<any> {
    // bind the DataManager instance to dataSource property
    const url = `${this._http.GET_API_URL()}${remoteUrl}`;

   return this._http.GETT<any>(remoteUrl)
    .pipe(
      tap(x=>console.log('ooo',x)),
      map(x=>x.data.data['result']),
      tap(x=>console.log(x))
    );

    
  }
  getDropdownRemoteCustomCategoryDataEJS(remoteUrl: string): DataManager {
    // bind the DataManager instance to dataSource property
    const url = `${remoteUrl}`;
    const staticUrl = 'http://localhost:3000/customCategory'

    return new DataManager({
      url: staticUrl,
      adaptor: new WebApiAdaptor,
      crossDomain: true
    });
  }

  upsert<T>(url: string, data: any) {
    if (data.id) {
      return this._http.PUT<T>(`${url}/${data.id}`, data);
    }
    return this._http.POST<T>(url, data);
  }
  getById(url: string, id: string) {
    const entityUrl = url + '/' + id;
    return this._http.GETT(entityUrl)
  }

  mergeNestedObjects(input) {
    const output = {};
    for (const key in input) {
      if (input.hasOwnProperty(key) && typeof input[key] === 'object') {
        Object.assign(output, input[key]);
      }
    }
    return output;
  }

  getCustomCategory$(module: string, key: string): Observable<any> {
    const url = `${module}/custom-category/${key}/dropdown`;
    const ccOptions = this._http.GETT<CCDropdownModelSingle[]>(url);
    return ccOptions;
  }

  editTitle = signal<string>('');
  setEditTitle(editTitle: string) {
    this.editTitle.set(editTitle);
  }

  private _entityData = new BehaviorSubject<any>(null);
  entityData$ = this._entityData.asObservable();

  setEntityData(btn: any) {
    this._entityData.next(btn);
  }
}
